'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseIcon = function CloseIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.41525,16.00025 L27.70725,5.70725 C28.09825,5.31825 28.09825,4.68525 27.70725,4.29325 C27.31625,3.90225 26.68325,3.90225 26.29325,4.29325 L16.00025,14.58625 L5.70725,4.29325 C5.31625,3.90225 4.68325,3.90225 4.29325,4.29325 C3.90225,4.68525 3.90225,5.31725 4.29325,5.70725 L14.58525,16.00025 L4.29325,26.29325 C3.90225,26.68525 3.90225,27.31725 4.29325,27.70725 C4.48825,27.90225 4.74425,28.00025 5.00025,28.00025 C5.25625,28.00025 5.51225,27.90225 5.70725,27.70725 L16.00025,17.41425 L26.29325,27.70725 C26.48825,27.90225 26.74425,28.00025 27.00025,28.00025 C27.25625,28.00025 27.51225,27.90225 27.70725,27.70725 C28.09825,27.31725 28.09825,26.68525 27.70725,26.29325 L17.41525,16.00025 L17.41525,16.00025 Z' })
  );
};

CloseIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = CloseIcon;